var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToastSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3751 12.1246C19.6251 15.8746 16.7976 19.4056 12.8301 20.1946C10.8951 20.5799 8.88781 20.345 7.0941 19.5232C5.30039 18.7014 3.81167 17.3346 2.83993 15.6175C1.8682 13.9003 1.46297 11.9204 1.68196 9.95959C1.90094 7.99877 2.73298 6.15702 4.05959 4.69658C6.78059 1.69958 11.3751 0.87458 15.1251 2.37458",
    stroke: "#4EA217",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.625 10.625L11.375 14.375L20.375 4.625",
    stroke: "#4EA217",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastSuccess);
export default __webpack_public_path__ + "static/media/toastSuccess.0f20c5992a0779741e608ba0318f59d8.svg";
export { ForwardRef as ReactComponent };